import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Icon } from "@mui/material";
const cardStyle = {
  backgroundColor: "#c3cbdc",
  // backgroundImage: "linear-gradient(147deg, #c3cbdc 0%, #edf1f4 74%)",
  transition: "transform 0.3s, box-shadow 0.3s ",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
};
const titleStyle = {};
const valueStyle = {};
const CustomCard = ({ title, value, action, cardcolor, image }) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleHover = () => {
    setIsHovered(!isHovered);
  };
  return (
    <div>
      <Card
        style={{
          ...cardStyle,
          backgroundColor: cardcolor,
          transform: isHovered ? "scale(1.05)" : "scale(1)",
          boxShadow: isHovered
            ? "0px 8px 16px rgba(0, 0, 0, 0.2)" // Box shadow on hover
            : "0px 4px 8px rgba(0, 0, 0, 0.1)", // Default box shadow
        }}
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
      >
        <CardContent>
          <table>
            <tbody>
              <tr>
                <td>
                  <img
                    src={image}
                    style={{ marginRight: "10px", height: "50px" }}
                  />
                </td>
                <td>
                  <b>
                    <h6 component="div" style={titleStyle}>
                      {title}
                    </h6>
                  </b>
                  <h2 style={valueStyle} color="textPrimary">
                    {value}
                  </h2>
                </td>
              </tr>
            </tbody>
          </table>
        </CardContent>
        {action ? <CardActions><Button size="small">{action}</Button></CardActions> : null}
      </Card>
    </div>
  );
};
export default CustomCard;
